import React, { useCallback } from 'react';
import { Box, Inscription } from '@common-fe/common-fe';

import { LockboxCheck, LockboxCheckType } from '@/modules/employer/components/Lockbox/lockbox.types';
import { MatchingListEmptyState } from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxMatchingList';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';
import useGetLockboxChecksQuery from '@/modules/employer/components/Lockbox/queries/useGetLockboxChecks.query';

import ChecksList from './components/ChecksList';
import useCheckCardsList from './hooks/useCheckCardsList';

interface Props {
  selectedCheckId?: string;
  onSelectCheck?: (checkId?: string, checkType?: LockboxCheckType, check?: LockboxCheck) => void;
}

const SuggestedChecks: React.FC<Props> = ({ selectedCheckId, onSelectCheck }) => {
  const { originalLockbox, isEditMode } = useLockboxDetailsStore();
  const checkNumber = originalLockbox?.ocr?.details?.checkNumber;
  const ocrAmount = originalLockbox?.ocr?.details?.amount;

  const { checks } = useGetLockboxChecksQuery({
    mode: 'SUGGESTED',
    searchValue: checkNumber,
  });

  const { fields } = useCheckCardsList({
    checks,
    ocrCheckNumber: checkNumber,
    ocrAmount,
  });

  const handleSelect = useCallback((checkId?: string) => {
    const check = checks?.find((item) => item.checkId === checkId);
    const checkType = check?.checkType === LockboxCheckType.LOCKBOX || check?.lockboxId
      ? LockboxCheckType.LOCKBOX
      : LockboxCheckType.CLAIM;
    onSelectCheck?.(checkId, checkType, check);
  }, [checks, onSelectCheck]);

  return (
    <Box>
      <Inscription color="textSecondary" margin={{ bottom: 'spacing8' }}>Suggested:</Inscription>

      <ChecksList
        fields={fields}
        selectedCheckId={selectedCheckId}
        onSelectCheck={handleSelect}
        isEditMode={isEditMode}
        showWarnings
        emptyState={(
          <Box margin={{ top: 'spacing8' }}>
            <MatchingListEmptyState testId="lockbox-checks" title="No Suggestions" />
          </Box>
        )}
      />
    </Box>
  );
};

export default SuggestedChecks;
